import { render, staticRenderFns } from "./mob-overview.vue?vue&type=template&id=b5aae47e&scoped=true"
import script from "./mob-overview.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-overview.vue?vue&type=style&index=0&id=b5aae47e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aae47e",
  null
  
)

export default component.exports